import { ACTIONS } from "./crewsReducer";
import { useContext } from "react";
import AuthContext from "../../components/context/AuthContext";
import axios from "axios";

const useCrews = ({ state, dispatch }) => {
  const authCtx = useContext(AuthContext);

  const setMode = (mode) => {
    dispatch({
      type: ACTIONS.SET_MODE,
      value: mode,
    });
    if (mode === "Edit") {
      dispatch({
        type: ACTIONS.INITIALIZE_FORM,
      });
    }
  };

  const contractorSelectHandler = (selectedOption) => {
    dispatch({
      type: ACTIONS.SET_CONTRACTOR,
      value: selectedOption,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const crewSelectHandler = (selectedOption) => {
    dispatch({
      type: ACTIONS.SET_CREW,
      value: selectedOption,
    });
    dispatch({ type: ACTIONS.INITIALIZE_CONTRACTOR });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const crewTypeSelectHandler = (selectedOption) => {
    dispatch({
      type: ACTIONS.SET_CREW_TYPE,
      value: selectedOption,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const convertContractorsHandler = (data) => {
    let options = data?.map((option) => {
      return { value: option, label: `${option?.LEGAL_NAME}` };
    });

    dispatch({
      type: ACTIONS.SET_CONTRACTOR_OPTIONS,
      value: options,
    });

    dispatch({ type: ACTIONS.INITIALIZE_CONTRACTOR });

    return options;
  };

  const convertCrewHandler = (data) => {
    let crews = data
      ?.map((option) => {
        return {
          value: option,
          label: `${option.FOREMAN} - ${option.CONTRACTOR}`,
        };
      })
      .sort((a, b) => (a.FOREMAN > b.FOREMAN ? 1 : -1));
    crews.unshift({ value: { id: 0 }, label: `Add New` });
    return crews;
  };

  const supervisorChangeHandler = (event) => {
    dispatch({
      type: ACTIONS.SET_SUPERVISOR,
      value: event.target.value,
    });
  };

  const foremanChangeHandler = (event) => {
    dispatch({
      type: ACTIONS.SET_FOREMAN,
      value: event.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const drillOperatorChangeHandler = (event) => {
    dispatch({
      type: ACTIONS.SET_DRILL_OPERATOR,
      value: event.target.value,
    });
  };

  const locatorChangeHandler = (event) => {
    dispatch({
      type: ACTIONS.SET_LOCATOR,
      value: event.target.value,
    });
  };

  const foremanPhoneChangeHandler = (event) => {
    dispatch({
      type: ACTIONS.FOREMAN_PHONE,
      value: event.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const foremanEmailChangeHandler = (event) => {
    dispatch({
      type: ACTIONS.FOREMAN_EMAIL,
      value: event.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const clearStatus = () => {
    dispatch({
      type: ACTIONS.SET_STATUS,
      value: "",
    });
  };

  const enabledStatusToggle = () => {
    dispatch({ type: ACTIONS.TOGGLE_ENABLED_STATUS });
  };

  // Updates state from the submission response handler.
  const submissionResponseHandler = (response) => {
    if (response && response.data && response.status === 200) {
      dispatch({
        type: ACTIONS.SET_STATUS,
        value: "Submission successful!",
      });
      dispatch({ type: ACTIONS.RESET_FORM });
    } else {
      dispatch({
        type: ACTIONS.SET_STATUS,
        value: `Submission error: ${
          response?.data ? response.data : response?.message
        }`,
      });
    }
  };

  const submitHandler = (event) => {
    event.preventDefault();
    dispatch({ type: ACTIONS.TOGGLE_LOADING });
    let formData = {
      drillOperator: state.drillOperator,
      foreman: state.foreman,
      foremanEmail: state.foremanEmail,
      foremanPhone: state.foremanPhone,
      locator: state.locator,
      contractorMCANumber: state.selectedContractor?.value?.MCA_NUMBER,
      crewType: state.selectedCrewType.value,
      supervisor: state.supervisor,
      crewGUID: state.selectedCrew?.value?.CREW_GUID,
      enabled: state.enabledStatus ? 1 : 0,
    };
    let url =
      state.mode === "Create"
        ? `${process.env.REACT_APP_API_URL}/data/createCrew`
        : `${process.env.REACT_APP_API_URL}/data/editCrew`;
    let authObj = { headers: { Authorization: `token ${authCtx.token}` } };
    axios
      .post(url, formData, authObj)
      .then((response) => {
        submissionResponseHandler(response);
      })
      .catch((error) => {
        submissionResponseHandler(error);
      });
  };

  return {
    contractorSelectHandler,
    convertContractorsHandler,
    convertCrewHandler,
    crewSelectHandler,
    crewTypeSelectHandler,
    drillOperatorChangeHandler,
    foremanChangeHandler,
    foremanEmailChangeHandler,
    foremanPhoneChangeHandler,
    locatorChangeHandler,
    state,
    supervisorChangeHandler,
    submitHandler,
    clearStatus,
    setMode,
    enabledStatusToggle,
  };
};

export default useCrews;
